import {StaticLandingType} from '../graphql/generated/types';

export const STATIC_LANDING_PAGE_SECTION_NAME = '고정랜딩리스트';
export const STATIC_LANDING_PAGE_NAME_MAP = {
  [StaticLandingType.TodayNew]: '오늘신작',
  [StaticLandingType.TodayUp]: '오늘UP',
  [StaticLandingType.Ranking]: '랭킹',
  [StaticLandingType.Original]: '오리지널',
  [StaticLandingType.Genre]: '장르전체',
  [StaticLandingType.FreeSeries]: '웹시리즈',
  [StaticLandingType.Event]: '추천이벤트',
  [StaticLandingType.DayOfWeek]: '요일연재',
};
